import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ArrowLeft, TrendingUp, Music, Podcast, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Trends = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [trends, setTrends] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.is_admin) {
      navigate('/');
      return;
    }
    loadTrends();
  }, [user, navigate]);

  const loadTrends = async () => {
    try {
      const response = await axios.get('/api/admin/trends');
      setTrends(response.data);
    } catch (error) {
      console.error('Error loading trends:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="min-h-screen bg-black text-white flex items-center justify-center">Chargement...</div>;
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="container mx-auto px-4 py-6 max-w-7xl">
        <div className="flex items-center space-x-4 mb-6">
          <button
            onClick={() => navigate('/admin')}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
          <div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text text-transparent">
              Tendances
            </h1>
            <p className="text-gray-400 mt-1">Contenus les plus populaires</p>
          </div>
        </div>

        {trends && (
          <div className="space-y-6">
            {/* Top Posts */}
            <div className="bg-white/5 border border-white/10 rounded-3xl p-6">
              <div className="flex items-center space-x-2 mb-4">
                <Music className="w-6 h-6 text-magenta-400" />
                <h3 className="text-xl font-bold">Top Gim Toli</h3>
              </div>
              {trends.top_posts?.length > 0 ? (
                <div className="space-y-3">
                  {trends.top_posts.map((post, index) => (
                    <div key={post.id} className="bg-white/5 rounded-xl p-4 flex items-center space-x-4">
                      <div className="w-8 h-8 bg-gradient-to-br from-magenta-500 to-violet-600 rounded-full flex items-center justify-center font-bold">
                        {index + 1}
                      </div>
                      <div className="flex-1">
                        <h4 className="font-semibold">{post.title || 'Sans titre'}</h4>
                        <p className="text-sm text-gray-400">Par: {post.user?.name}</p>
                      </div>
                      <div className="text-right">
                        <p className="font-bold text-magenta-400">{post.likes_count} ❤️</p>
                        <p className="text-sm text-gray-400">{post.plays_count} écoutes</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center py-8 text-gray-400">Aucun contenu pour le moment</p>
              )}
            </div>

            {/* Top Podcasts */}
            <div className="bg-white/5 border border-white/10 rounded-3xl p-6">
              <div className="flex items-center space-x-2 mb-4">
                <Podcast className="w-6 h-6 text-violet-400" />
                <h3 className="text-xl font-bold">Top Podcasts</h3>
              </div>
              {trends.top_podcasts?.length > 0 ? (
                <div className="space-y-3">
                  {trends.top_podcasts.map((podcast, index) => (
                    <div key={podcast.id} className="bg-white/5 rounded-xl p-4 flex items-center space-x-4">
                      <div className="w-8 h-8 bg-gradient-to-br from-violet-500 to-purple-600 rounded-full flex items-center justify-center font-bold">
                        {index + 1}
                      </div>
                      <div className="flex-1">
                        <h4 className="font-semibold">{podcast.title}</h4>
                        <p className="text-sm text-gray-400">Par: {podcast.user?.name}</p>
                      </div>
                      <div className="text-right">
                        <p className="font-bold text-violet-400">{podcast.rating_avg.toFixed(1)} ⭐</p>
                        <p className="text-sm text-gray-400">{podcast.plays_count} écoutes</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center py-8 text-gray-400">Aucun contenu pour le moment</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Trends;